import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { useRef } from "react";
import { useTilt } from "@/lib/motion";
import { SectionHeading } from "@/components/site/SectionHeading";
import { StaffTeam } from "@/components/site/StaffTeam";
import { useText } from "@/lib/useText";
import { VideoBackdrop } from "@/components/site/VideoBackdrop";


function TiltCard({ children, testId }) {
  const ref = useRef(null);
  useTilt(ref, 5);
  return (
    <article ref={ref} className="tilt-card group relative flex flex-col overflow-hidden bg-eden-surface p-6 hover:border-eden-orange/40 sm:p-7" data-testid={testId}>
      {children}
    </article>
  );
}

export function CardIcon({ name, size = 20, className = "" }) {
  const Icon = Icons[name] || Icons.Info;
  return <Icon size={size} className={className} aria-hidden="true" />;
}

export default function Informacoes() {
  const { content } = useContent();
  const t = useText();
  return (
    <>
    <section className="relative py-16 sm:py-24" aria-labelledby="info-title" data-testid="info-page">
      <VideoBackdrop opacity={0.22} className="h-[420px]" />
      <div className="container-eden relative">
        <SectionHeading id="info-title" eyebrow={t("info_eyebrow")} title={t("info_title")} text={t("info_text")} />
        <div className="mt-12 grid gap-px overflow-hidden rounded-md border border-eden-border bg-eden-border sm:grid-cols-2 lg:grid-cols-4" data-testid="info-grid">
          {content.info_cards.map((card, i) => (
            <TiltCard key={card.id} testId={`info-card-${card.id}`}>
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-sm border border-eden-border text-eden-orange"><CardIcon name={card.icon} /></span>
                <span className="font-mono text-xs text-eden-muted">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="mt-6 font-display text-lg font-semibold text-eden-text">{card.title}</h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-eden-secondary">{card.body}</p>
              {card.link_url && card.link_label && (
                <a href={card.link_url} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-eden-text underline-offset-4 hover:text-eden-orange hover:underline" data-testid={`info-card-link-${card.id}`}>
                  {card.link_label} <ArrowUpRight size={14} aria-hidden="true" />
                </a>
              )}
            </TiltCard>
          ))}
        </div>
      </div>
    </section>
    <StaffTeam />
    </>
  );
}
